import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SaveIcon from '@mui/icons-material/Save';
import { IPurchaseAddEditRequest } from '../../../../model/scp/purchase/request/purchase-add-edit-request';
import { IPurchaseItemResponse } from '../../../../model/scp/purchase/response/purchase-item-response';
import { Box, Button, Grid, IconButton, LinearProgress, Tooltip } from '@mui/material';
import DefaultDrawer from '../../../../components/default-drawer';
import { DefaultDialogProps } from '../../../../components/default-dialog';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import PurchaseItemResultDrawer from './purchase-item-result-drawer';
import PurchaseItemForm from './purchase-item-form';
import { dataGridLocaleConfig } from '../../../../config/data-grid-locale';
import { usePurchaseItemController } from './controllers/purchase-item-controller';
import PurchaseItemImportDialog from './purchase-item-import-dialog';
import PurchaseItemImportErrorsDialog from './purchase-item-import-errors-dialog';

export interface IItemPurchaseDataTableProps {
    setItemsPurchaseJson: (value: string) => void,
    purchaseRequest: IPurchaseAddEditRequest,
    purchaseId?: string | undefined,
    itemsPurchaseJson?: string
};

export default function PurchaseItemDataTable({ props }: { props: IItemPurchaseDataTableProps }) {
    const controller = usePurchaseItemController(
        props.purchaseId,
        props.purchaseRequest.modalityId,
        props.setItemsPurchaseJson,
        props.itemsPurchaseJson
    );

    const {
        itemPurhase,
        openDrawer,
        setOpenDrawer,
        materialService,
        benefitType,
        judgementCriteria,
        categoryItemPurchase,
        purchaseItemSituation,
        titleDrawer,
        purchaseItemsResponse,
        purchaseItemsRequest,
        loadMoreData,
        openResultDrawer,
        selectedItemForResult,
        itemResult,
        openImportDialog,
        openImportErrorsDialog,
        importErrors,
        importSuccessCount,
        importTotalCount,
        handleOnChange,
        handleCurrencyChange,
        addItem,
        editItem,
        saveItem,
        deleteItem,
        openItemResultDrawer,
        closeItemResultDrawer,
        handleResultSave,
        handlePageChange,
        showDialog,
        showMessage,
        handleDownloadTemplate,
        handleUploadFile,
        openImportDialogHandler,
        closeImportDialog,
        closeImportErrorsDialog
    } = controller;

    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 4, maximumFractionDigits: 4
    });

    const decimalFormmatter = new Intl.NumberFormat('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: 4, maximumFractionDigits: 4
    });

    const columns: GridColDef<IPurchaseItemResponse>[] = [
        {
            field: 'number',
            headerName: 'Nº',
            minWidth: 80, sortable: false,
            disableColumnMenu: true,
            align: 'right',
            headerAlign: 'right'
        },

        {
            field: 'description',
            headerName: 'Descrição',
            minWidth: 160, sortable: false,
            disableColumnMenu: true
        },
        {
            field: 'quantity',
            headerName: 'Quantidade',
            minWidth: 130, sortable: false,
            disableColumnMenu: true,
            align: 'right',
            headerAlign: 'right',
            valueFormatter: ({ value }) => decimalFormmatter.format(Number(value)),
        },
        {
            field: 'unitMeasure',
            headerName: 'Unidade de Medida',
            minWidth: 160,
            sortable: false,
            disableColumnMenu: true
        },
        {
            field: 'unitValueEstimated',
            headerName: 'Valor Estimado Unitário',
            minWidth: 190, sortable: false,
            disableColumnMenu: true,
            align: 'right',
            headerAlign: 'right',
            valueFormatter: ({ value }) => currencyFormatter.format(Number(value)),
        },
        {
            field: 'amount',
            headerName: 'Valor Total',
            minWidth: 150,
            sortable: false,
            disableColumnMenu: true, align: 'right',
            headerAlign: 'right',
            valueFormatter: ({ value }) => currencyFormatter.format(Number(value)),
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: '',
            width: 100,
            renderCell: (params) => {

                return [
                    <Tooltip title="Editar" key="edit">
                        <IconButton aria-label="Editar" onClick={async () => {

                            editItem(params.row.number);

                        }}>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>,
                    (purchaseItemsRequest.id !== undefined &&
                        <Tooltip title="Resultado" key="result">
                            <IconButton aria-label="Resultado" onClick={() => {
                                if (params.row.number !== undefined) {
                                    openItemResultDrawer(params.row.number);
                                }
                            }}>
                                <AssessmentIcon />
                            </IconButton>
                        </Tooltip>
                    ),
                    (purchaseItemsRequest.id === undefined &&
                        <Tooltip title="Excluir" key="delete">
                            <IconButton aria-label="Excluir" onClick={async () => {
                                showDialog({
                                    open: true,
                                    message: "Deseja realmente excluir o item?",
                                    onYesClick: () => {
                                        deleteItem(params.row.number);
                                    }
                                } as DefaultDialogProps);
                            }}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip >),
                ];
            }
        }
    ];

    const formItem = () => {
        return (
            <React.Fragment>
                <DefaultDrawer
                    title={titleDrawer}
                    isOpen={openDrawer}
                    actions={() => {
                        return (
                            <Button variant="contained" onClick={saveItem} endIcon={<SaveIcon />}>
                                Salvar
                            </Button>
                        )
                    }}
                    onClose={() => {
                        setOpenDrawer(false);
                    }}
                >
                    <PurchaseItemForm props={{
                        itemPurchase: itemPurhase,
                        materialService,
                        benefitType,
                        judgementCriteria,
                        categoryItemPurchase,
                        purchaseItemSituation,
                        purchaseId: props.purchaseId,
                        handleOnChange,
                        handleCurrencyChange
                    }} />
                </DefaultDrawer>
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>
            {formItem()}
            <Box sx={{ textAlign: 'right' }}>
                <Grid container spacing={2} sx={{ mt: '10px', mb: '10px', pr: '10px', justifyContent: 'flex-end' }}>
                    {purchaseItemsRequest.id === undefined && (
                        <>
                            <Grid item xs="auto">
                                <Button
                                    variant="outlined"
                                    size="large"
                                    startIcon={<DownloadIcon />}
                                    onClick={handleDownloadTemplate}
                                >
                                    Baixar Template
                                </Button>
                            </Grid>
                            <Grid item xs="auto">
                                <Button
                                    variant="outlined"
                                    size="large"
                                    startIcon={<UploadIcon />}
                                    onClick={openImportDialogHandler}
                                >
                                    Importar Planilha
                                </Button>
                            </Grid>
                        </>
                    )}
                    <Grid item xs="auto">
                        <Button variant="contained" component="label" size="large" endIcon={<PlaylistAddIcon />}
                            onClick={() => {
                                if (props.purchaseRequest.modalityId !== undefined && props.purchaseRequest.modalityId !== null && props.purchaseRequest.modalityId !== 0) {
                                    addItem();
                                } else {
                                    showMessage({ message: 'Antes de adicioanr um item é necessário selecionar  a modalidae', type: 'error', open: true });
                                }

                            }}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <DataGrid
                columns={columns}
                disableSelectionOnClick
                onPageChange={handlePageChange}
                paginationMode="server"
                components={{
                    LoadingOverlay: LinearProgress,
                }}
                loading={loadMoreData}
                rowsPerPageOptions={[purchaseItemsResponse.pageSize]}
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                    sorting: {
                        sortModel: [{ field: 'number', sort: 'asc' }],
                    },
                }}
                rowCount={purchaseItemsResponse.totalRecords}
                rows={purchaseItemsResponse.items}
                pagination={undefined}
                getRowId={(row: any) => row.number}
                localeText={dataGridLocaleConfig}
            />
            {selectedItemForResult && props.purchaseId && (
                <PurchaseItemResultDrawer props={{
                    isOpen: openResultDrawer,
                    onClose: closeItemResultDrawer,
                    purchaseId: parseInt(props.purchaseId),
                    itemNumber: selectedItemForResult,
                    resultData: itemResult,
                    onSave: handleResultSave
                }} />
            )}

            <PurchaseItemImportDialog
                open={openImportDialog}
                onClose={closeImportDialog}
                onImport={handleUploadFile}
            />

            <PurchaseItemImportErrorsDialog
                open={openImportErrorsDialog}
                onClose={closeImportErrorsDialog}
                errors={importErrors}
                successCount={importSuccessCount}
                totalCount={importTotalCount}
            />
        </React.Fragment>
    )
}